import './style.scss'

const prefixCls = 'sl-badge';
const initColor = ['default','success','error','warning','processing'];

const Badge = {
  name:'Badge',
  props:['size','shape','icon','status'],
  computed:{
    classes(){
      return [`${prefixCls}`,{
        [`${prefixCls}-status`]:!!this.status,
      }]
    },
    styles(){
      if(this.status && !initColor.includes(this.status)){
        return {backgroundColor:this.status}
      }else{
        return {}
      }
    }
  },
  methods:{

  },
  render(){
    const { $scopedSlots , status } = this
    let node;
    if( status ){
      node = <span style={this.styles} class={[`${prefixCls}-status-dot`,`${prefixCls}-status-${status}`]}></span>
    }

    return <span class={this.classes}>{node}</span>
  }
}

export default Badge